var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "before-query-search": _vm.beforeQuerySearch,
          res: "page",
        },
        on: {
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.spuCode"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("goodsPage.spuCode"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockChange.header.categoryId"
                          ),
                          prop: "categoryId",
                        },
                      },
                      [
                        _c("BjGoodsTypeTreeSelect", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.categoryId"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "categoryId", $$v)
                            },
                            expression: "queryParams.categoryId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockChange.header.warehouseCode"
                          ),
                          prop: "warehouseCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.warehouseCode"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.warehouseCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "warehouseCode", $$v)
                            },
                            expression: "queryParams.warehouseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockChange.header.warehouseName"
                          ),
                        },
                      },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.warehouseName"
                            ),
                            "value-code": "code",
                          },
                          model: {
                            value: _vm.queryParams.warehouseCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "warehouseCode", $$v)
                            },
                            expression: "queryParams.warehouseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockChange.header.recordTypeMeaning"
                          ),
                          prop: "recordTypeCodeList",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.recordTypeMeaning"
                            ),
                            multiple: "",
                            "lov-code": "STOCK.RECORD_TYPE",
                          },
                          model: {
                            value: _vm.queryParams.recordTypeCodeList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "recordTypeCodeList",
                                $$v
                              )
                            },
                            expression: "queryParams.recordTypeCodeList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockChange.header.warehouseType"
                          ),
                          prop: "warehouseTypeCodeList",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.warehouseType"
                            ),
                            multiple: "",
                            "lov-code": "STOCK.WAREHOUSE_TYPE",
                          },
                          model: {
                            value: _vm.queryParams.warehouseTypeCodeList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "warehouseTypeCodeList",
                                $$v
                              )
                            },
                            expression: "queryParams.warehouseTypeCodeList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "seniorForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("InternalOrder.order") } },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.changeTime"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockChange.header.recordCode"
                          ),
                          prop: "recordCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessStockChange.header.recordCode"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.recordCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "recordCode", $$v)
                            },
                            expression: "queryParams.recordCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "code"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onView(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[col.prop]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STOCK_LOCK_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled:
                                            scope.row.status !== "success",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onStatus(
                                              "close",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("disableText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled:
                                            scope.row.status !== "close",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onStatus(
                                              "wait",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("enableText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled: scope.row.status !== "wait",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onStatus(
                                              "abandon",
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessStockChange.voidBtn"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }